import React from "react";

import { EuiAvatar, EuiFlexGroup, EuiFlexItem, EuiTextColor } from "@elastic/eui";

import toEnName from "arabic-name-to-en";

function ProfileAvatar({ id, title = "", subtitle, imageUrl }) {
    return (
        <EuiFlexGroup gutterSize="none">
            <EuiFlexItem
                grow={false}
                style={{ marginInlineEnd: 10 }}
            >
                <EuiAvatar
                    size="l"
                    name={toEnName(title)}
                    imageUrl={imageUrl}
                />
            </EuiFlexItem>

            <EuiFlexItem
                grow={false}
                style={{ justifyContent: "space-between" }}
            >
                <EuiTextColor color="subdued">#{id}</EuiTextColor>
                <span>
                    {title} <EuiTextColor color="subdued">{subtitle}</EuiTextColor>
                </span>
            </EuiFlexItem>
        </EuiFlexGroup>
    );
}

export default ProfileAvatar;
